import React from 'react'

// CardCurrencyBrandIntro returns an introduction for a card brand currency table.
// CardCurrencyBrandIntro takes no input.

const CardCurrencyBrandIntro = () => {
  return (
    <>
      <p>
        PayPal's Expanded Checkout program supports 142 currencies for Visa and
        Mastercard, and 124 currencies for American Express.
      </p>
      <h3>Supported currencies</h3>
      <p>
        This table shows the currencies that PayPal supports for its Expanded
        Checkout program:
      </p>
      <p>
        <ul>
          <li>
            The <strong>V/MC</strong> column shows whether a currency is carried
            by the Visa and Mastercard brands.
          </li>
          <li>
            The <strong>Amex</strong> column shows whether a currency is carried
            by the American Express brand.
          </li>
          <li>
            The <strong>Local</strong> column shows whether a currency is
            carried by a local brand or financial entity.
          </li>
        </ul>
      </p>
      <p>
        Select the <strong>Card brand currency table</strong> and scroll or use
        the search bar to find details about the card brands and currencies
        supported in each country:
      </p>
    </>
  )
}

export default CardCurrencyBrandIntro
